import { InputSettings } from './types';
import { Theme } from '../../../themeBase';

export const inputSettings: InputSettings = {
  componentVariants: {
    variant: {
      prop: 'variant',
      variants: {
        primary: {
          fontWeight: 0,
          fontFamily: 'secondary',
          color: 'black.main',
          borderColor: 'gray.light',
          backgroundColor: 'white.main',
          borderRadius: 3,
          boxShadow: (props: Theme) => props.boxShadows.input,
          '&::placeholder': {
            color: 'gray.main',
          },
        },
      },
    },
    inputSize: {
      prop: 'inputSize',
      variants: {
        small: {
          fontSize: '0',
          lineHeight: '0',
          paddingTop: 2,
          paddingRight: 4,
          paddingBottom: 2,
          paddingLeft: 4,
        },
        medium: {
          fontSize: '1',
          lineHeight: '1',
          paddingTop: 3,
          paddingRight: 5,
          paddingBottom: 3,
          paddingLeft: 5,
        },
      },
    },
    status: {
      prop: 'status',
      variants: {
        disabled: {
          cursor: 'not-allowed',
          borderColor: 'gray.light',
          backgroundColor: 'white.dark',
          color: 'gray.main',
          boxShadow: 'none',
          '&:hover, &:active, &:focus, &:focus-visible': {
            borderColor: 'gray.light',
            backgroundColor: 'white.dark',
          },
        },
        error: {
          borderColor: 'danger.main',
          boxShadow: 'none',
          '&:hover, &:active, &:focus, &:focus-visible': {
            borderColor: 'danger.main',
            backgroundColor: 'white.main',
          },
        },
        active: {
          '&:hover, &:active, &:focus, &:focus-visible': {
            borderColor: 'primary.main',
            backgroundColor: 'primary.extraLight',
            outline: 'none',
            boxShadow: 'none',
          },
        },
      },
    },
    iconSize: {
      prop: 'iconSize',
      variants: {
        small: {
          width: 0,
          height: 0,
          color: 'gray.light',
        },
        medium: {
          width: 1,
          height: 1,
          color: 'gray.light',
        },
      },
    },
  },
};
